// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.coming-soon[data-v-5c85b068] {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  min-height: 50vh;\n  padding: 24px;\n  text-align: center;\n}\n.coming-soon__text[data-v-5c85b068] {\n  margin: 16px 0 0;\n  font-family: \"Artificial Intelligence\", sans-serif;\n  font-size: 28px;\n  font-weight: 600;\n  color: #0f172a;\n}\n", ""]);
// Exports
module.exports = exports;
